import './order_confirmation.css';
import { Link, useParams } from "react-router-dom";
import { BagIcon } from "../../assets/icons/BagIcon";
import { useEffect, useRef, useState } from "react";
import { BusinessProvider, useBusiness } from "../../context/BusinessContext";
import { AppleMap } from "../../components/AppleMap/AppleMap";
import { DeliveryMethod } from "../../Enum/DeliveryMethod";
import { PaymentMethodNames } from "../../Enum/PaymentMethod";
import { useServer } from '../../context/ServerContext';
import { orderEndpoints } from '../../env';

export const orderConfirmationWrapper = () => {
    return (
        <BusinessProvider>
            <OrderConfirmation />
        </BusinessProvider>
    );
}

const OrderConfirmation = () => {
    //HOOKS
    const { businessLocation, businessInfo } = useBusiness();
    const { getRequest } = useServer();

    const { orderId, accessKey } = useParams();

    //REFS
    const mapRef = useRef();

    //STATES
    const [order, setOrder] = useState(null);

    //FUNCTIONS
    const loadOrder = () => {
        getRequest(orderEndpoints.get_order, {id: orderId, access_key: accessKey}, (res) => {
            if (res[0])
            {
                setOrder(res[1].order);
            }
        });
    }

    //EFFECTS
    useEffect(() => {
        loadOrder();
    }, []);

    useEffect(() => {
        if (businessLocation && businessInfo && mapRef.current)
        {
            mapRef.current.deleteAllAnotations();
            mapRef.current.centerToCoordinates(businessLocation.latitude, businessLocation.longitude);
            mapRef.current.addAnnotation(businessLocation.latitude, businessLocation.longitude, businessInfo.name);
        }
    }, [businessLocation, mapRef, businessInfo]);

    return (
        <>
            <div className='order_confirmation_app'>
                <div className='animation_container'>
                    <div className='media'>
                        <span className='circle'></span>
                        <BagIcon />
                    </div>
                    <div className='info'>
                        <h2>Thank You!</h2>
                        <p>
                            Hi! <span>{order && order.contact_details.name}</span>, a confirmation email was sent to your inbox.
                        </p>
                    </div>
                </div>
                <div className='summary_container'>
                    <div className='address_container'>
                        <div className='info'>
                            <h2>Restaurant address:</h2>
                            <p>{ businessLocation && businessLocation.address }</p>
                        </div>
                        <div>
                            <AppleMap 
                                id={'order_confirmation_map_container'}
                                lat={0}
                                long={0}
                                ref={mapRef}
                            />
                        </div>
                    </div>
                    <div className='info_container'>
                        <div>
                            <h2>Order N°</h2>
                            <p>#{order && order.id}</p>
                        </div>
                        <hr />
                        {
                            order && order.delivery.delivery_type === DeliveryMethod.PICKUP && (
                                <div>
                                    <h2>Pickup Time</h2>
                                    {/*<p>#{order.pickup.eta}</p>*/}
                                </div>
                            )
                        }
                        {
                            order && order.delivery.delivery_type === DeliveryMethod.DELIVERY && (
                                <div>
                                    <h2>Delivery</h2>
                                    {/* <p>#{order.pickup.eta}</p> */}
                                </div>
                            )
                        }
                        {
                            order && order.delivery.delivery_type === DeliveryMethod.EAT_IN && (
                                <div>
                                    <h2>Eat in</h2>
                                    {/*<p>#{order.pickup.eta}</p>*/}
                                </div>
                            )
                        }
                        <hr />
                        <div>
                            <h2>Payment Method</h2>
                            <p>#{order && PaymentMethodNames[order.payment.payment_method]}</p>
                        </div>
                        <hr />
                        <div>
                            <h2>Total</h2>
                            <p>${order && order.pricing.total / 100}</p>
                        </div>
                    </div>
                    <div className='button_container'>
                        <Link to={'/'}>
                            Back to home
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}